import { defineStore } from "pinia";
import { API_BASE_URL, GETBALANCE, GETSUBSCRIPTION } from "../utils/appConst";

const getBalance = `${API_BASE_URL}${GETBALANCE}`;
const getSubscription = `${API_BASE_URL}${GETSUBSCRIPTION}`;
interface UserProfileState {
  balance: number | 0.0;
  subscriptionType: string;
  subscriptionStartDate: string | "";
  subscriptionEndDate: string | "";
  speechToTextVolume: number | 0.0;
  textTranslationVolume: number | 0.0;
  textToSpeechVolume: number | 0.0;
  userDeposit: number | 0.0;
  isStudent: boolean;
  subscriptionId: string | "";
  lastPackage: string | "";
}

export const useUserProfile = defineStore("userProfile", {
  state: (): UserProfileState => ({
    balance: 0 as number,
    subscriptionType: "",
    lastPackage: "",
    subscriptionStartDate: "",
    subscriptionEndDate: "",
    speechToTextVolume: 0.0,
    textTranslationVolume: 0.0,
    textToSpeechVolume: 0.0,
    userDeposit: 0.0,
    isStudent: false,
    subscriptionId: "",
  }),

  getters: {
    /**
     * Non-FREE plan with a valid subscription end (when the plan uses one).
     * Aligns with checks in audio/video process flows (CONSUMEASYOUPAY uses end date too).
     */
    hasActivePaidSubscription(): boolean {
      const sub = this.subscriptionType;
      if (!sub || sub === "FREE") return false;
      const now = Date.now();
      if (sub === "CONSUMEASYOUPAY") {
        if (!this.subscriptionEndDate) return true;
        const end = new Date(this.subscriptionEndDate).getTime();
        return !Number.isNaN(end) && now <= end;
      }
      if (!this.subscriptionEndDate) return false;
      const end = new Date(this.subscriptionEndDate).getTime();
      return !Number.isNaN(end) && now <= end;
    },
  },

  actions: {
    setBalance(balance: number): void {
      this.balance = balance;
    },
    async getUserBalance(token: string) {
      try {
        const response = await fetch(getBalance, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "ngrok-skip-browser-warning": "69420",
          },
        });

        if (response.ok) {
          const result = await response.json();
          if (result.message) {
            this.setBalance(result.balance);
          }
        }
      } catch (error) {
        console.error("Error validating token:", error);
        return false;
      }
    },
    async getUserSubscription(token: string) {
      try {
        const response = await fetch(getSubscription, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "ngrok-skip-browser-warning": "69420",
          },
        });

        if (response.ok) {
          const result = await response.json();
          if (result.message) {
            this.subscriptionType = result.data.subscriptionType;
            this.subscriptionStartDate = result.data.subscriptionStartDate;
            this.subscriptionEndDate = result.data.subscriptionEndDate;
            this.speechToTextVolume = result.data.speechToTextVolume;
            this.textTranslationVolume = result.data.textTranslationVolume;
            this.textToSpeechVolume = result.data.textToSpeechVolume;
            this.userDeposit = result.data.userDeposit;
            this.isStudent = result.data.isStudent;
            this.subscriptionId = result.data.subscriptionId;
            this.lastPackage = result.data.lastPackage || "";
          }
        }
      } catch (error) {
        console.error("Error validating token:", error);
        return false;
      }
    },
  },
});
